import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';

const CPFPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ paddingTop: '80px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: '500px', textAlign: 'center', padding: '2rem' }}>
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          background: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 1.5rem'
        }}>
          <Clock size={40} style={{ color: '#f59e0b' }} />
        </div>
        <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>
          Bientôt disponible
        </h1>
        <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
          Les formules CPF sont en cours de préparation et seront disponibles prochainement.
        </p>
        <button onClick={() => navigate(-1)} className="btn-primary" data-testid="back-btn">
          Retour
        </button>
      </div>
    </div>
  );
};

export default CPFPage;
